import React, { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import { Checkbox, FormControlLabel, List, Radio, Typography } from "@mui/material"
import { StyledListItem } from "shared/styled/General"
import { IApiResult } from "auth/interface/api.interface"
import { IDocumentFolder } from "pages/documents/interface/folder.interface"
import { StyledFormControlLabelBold } from "components/PermissionAndRoles/PermissionAndRolesSelect.styled"
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next"

interface RoleListProps {
  roleResult: IApiResult
}

interface Role {
  id: number
  name: string
}

const StyledList = styled(List)({
  "& > li > ul": {
    width: "100%"
  },
  width: "100%"
})

export const CustomRoleSelector = ({ roleResult }: RoleListProps) => {
  const { values, setFieldValue } = useFormikContext<IDocumentFolder>()
  const [isRoleless, setIsRoleless] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    setIsRoleless(values.customRoleIds.length === 0)
  }, [values.customRoleIds])

  return (
    <StyledList>
      <Typography variant="h5">{t("settings.form.roles", "Roles")}</Typography>
      <FormControlLabel
        label={<Typography fontWeight={600}>{t("global.all_users", "All users")}</Typography>}
        control={
          <Radio
            id="isRoleless"
            checked={isRoleless || values.customRoleIds.length === 0}
            onChange={(_, checked) => {
              if (checked) {
                setFieldValue("customRoleIds", [])
              }
            }}
          />
        }
      />
      {roleResult.data?.map((role: Role) => {
        const selectedRoles: number[] = values.customRoleIds || []
        return (
          <StyledListItem disablePadding sx={{ paddingLeft: "16px" }} key={role.id}>
            <StyledFormControlLabelBold
              label={role.name}
              control={
                <Checkbox
                  id="customRoleIds"
                  checked={selectedRoles.includes(role.id)}
                  onChange={(_, checked) => {
                    if (checked) {
                      setFieldValue("customRoleIds", [...selectedRoles, role.id])
                    } else {
                      setFieldValue("customRoleIds", selectedRoles.filter((x) => x !== role.id))
                    }
                  }}
                />
              }
            />
          </StyledListItem>
        )
      })}
    </StyledList>
  )
}